interface ProgressBarProps {
  current: number;
  total: number;
}

export function ProgressBar({ current, total }: ProgressBarProps) {
  const percent = Math.round((current / total) * 100);

  return (
    <div className="mb-6">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-brand">
          Question {current} of {total}
        </span>
        <span className="text-sm text-brand-slate">{percent}%</span>
      </div>
      <div className="w-full bg-cream/30 rounded-full h-2">
        <div
          className="bg-scarlet h-2 rounded-full transition-all duration-300 ease-in-out"
          style={{ width: `${percent}%` }}
          role="progressbar"
          aria-valuenow={percent}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
}
